<template>
  <div class="grey800 pa-4">
    <v-form v-model="valid" @submit.prevent="onSave">
      <v-row>
        <v-col cols="12">
          <label for="fieldClientSecret" class="grey100--text d-block font-weight-bold">New client secret</label>
          <p class="text-body-2 mb-3">
            Your client secret is used to generate provably fair outcomes in certain games.
            Creating a new one will also rotate your server seed.
          </p>
          <v-text-field
            id="fieldClientSecret" v-model="input" :rules="rules"
            placeholder="Random words or characters"
            class="settings-btn rounded-0"
            dense solo flat
            background-color="grey600"
          >
            <template #append>
              <v-btn
                class="font-weight-semibold text-caption rounded-0 mr-n2"
                color="blue400" small
                :ripple="false" depressed text
                @click="onGenerate"
              >
                Generate
              </v-btn>
            </template>
            <template #append-outer>
              <v-btn
                class="px-8 font-weight-semibold text-caption green500--text rounded-0"
                color="green800" height="38"
                :ripple="false" depressed
                :disabled="!valid"
                :loading="loading"
                @click="onSave"
              >
                Change
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    loading: Boolean,
  },
  data() {
    return {
      valid: false,
      input: this.value,
      rules: [
        v => !!v || 'Required',
        v => (v && v.length >= 6) || 'At least 6 characters',
        v => (v && v.length <= 32) || 'Max. 32 characters',
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
    }),
  },
  methods: {
    onSave() {
      if (!this.valid) return
      this.$emit('update', this.input)
    },
    onGenerate() {
      this.input = btoa(Math.random().toString(36).substring(2)).replace(/=/g, '')
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-btn {
  @include xs {
    flex-wrap: wrap;
  }
}

::v-deep .settings-btn {
  .v-input__append-outer {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>
